import React from 'react';
import { Card, Typography, Empty } from 'antd';
import { CarOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Transport = () => (
  <div>
    <Title level={3}>Transporte</Title>
    <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', padding: 40 }}>
      <Empty
        image={<CarOutlined style={{ fontSize: 64, color: '#e17055' }} />}
        description={
          <div>
            <Title level={4} style={{ marginTop: 16 }}>Transfaza</Title>
            <Paragraph type="secondary">
              60 tractores, 120 pipas. Integración con GM Transport.
            </Paragraph>
            <Paragraph type="secondary">Disponible en Fase 5</Paragraph>
          </div>
        }
      />
    </Card>
  </div>
);

export default Transport;
